import dayjs from "dayjs";

import { DATE_FORMATS } from "../../../constants/global.constants";

export const getUserLicenses = (response) => {
  const payload = response?.data ?? response;
  if (Array.isArray(payload)) {
    return payload?.[0]?.licenses || [];
  }
  return payload?.licenses || [];
};

export const hasSelectedLicense = (licenses, selectedLicenseId) =>
  (licenses || []).some((license) => license?.id === selectedLicenseId);

export const addUserToTable = (
  email,
  error,
  userData,
  setRowData,
  warning = "",
) => {
  setRowData((prev) => [
    ...prev,
    {
      id: Date.now() + Math.random(),
      email,
      error,
      warning,
      userData,
    },
  ]);
};

const normalizeDate = (date, format = DATE_FORMATS.YYYY_MM_DD) => {
  if (!date) {
    return null;
  }

  if (dayjs.isDayjs(date)) {
    return date.format(format);
  }

  const parsed = dayjs(date);
  if (parsed.isValid()) {
    return parsed.format(format);
  }

  return date;
};

export const createAssignLicensePayload = (
  selectedUsers,
  licenseObj,
  expiryDate,
  keyAccountManager,
) => {
  const normalizedExpiryDate = normalizeDate(expiryDate);
  const normalizedAssignedDate = normalizeDate(
    new Date(),
    DATE_FORMATS.YYYY_MM_DD_HH_MM_SS,
  );

  return (selectedUsers || []).map((user) => ({
    userId: user?.userData?.[0]?.userId,
    email: user?.email,
    licenses: [
      {
        id: licenseObj?.id,
        name: licenseObj?.name,
        assignedDate: normalizedAssignedDate,
        expiryDate: normalizedExpiryDate,
        licenseType: licenseObj?.licenseType,
        licenseApprover: keyAccountManager,
      },
    ],
  }));
};

export const validateEmail = (email, EMAIL_VALIDATOR, t) => {
  if ([",", ";"].some((char) => email.includes(char))) {
    return t("licenseManagement.enterOneEmail");
  }
  if (email && !EMAIL_VALIDATOR.test(email)) {
    return t("licenseManagement.enterValidEmail");
  }
  return "";
};
